app.config(function ($translateProvider) {
    $translateProvider.translations('en-gb', {
        STATUS_ACTIVE: 'Active',
        STATUS_INACTIVE: 'Inactive',
        STATUS_DRAFT: 'Draft',
        STATUS_TRAINING: 'Training'
    });
});
